(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    }
})(this, function () {
    function extend (target, source, source2) {
        var key;
        for (key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key];
            }
        }
        if (source2) {
            extend(target, source2);
        }
        return target;          
    }
    return extend;
});